/* Squish Monster: daily deal countdown and the bundle picker. No dependencies. */
(() => {
  /* ---------- Daily deal countdown ---------- */
  // Counts down to the next midnight in the store's timezone (the deal is reset every night),
  // then starts again. Markup: [data-sm-countdown][data-tz="America/Chicago"] with
  // [data-hours] [data-mins] [data-secs] children.
  function zonedParts(tz, date) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(date);
    const get = (type) => Number((parts.find((p) => p.type === type) || {}).value || 0);
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour') % 24, min: get('minute'), s: get('second') };
  }

  // Offset (ms) of the zone's wall clock from UTC at a given instant.
  function zoneOffset(tz, date) {
    const p = zonedParts(tz, date);
    return Date.UTC(p.y, p.m - 1, p.d, p.h, p.min, p.s) - Math.floor(date.getTime() / 1000) * 1000;
  }

  // Real seconds until the next 00:00 in `tz`. Uses actual elapsed time, so the 23h and 25h
  // daylight-saving nights count correctly.
  function secondsToMidnight(tz) {
    const now = new Date();
    try {
      const p = zonedParts(tz, now);
      const wallMidnight = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0, 0);
      let target = wallMidnight - zoneOffset(tz, new Date(wallMidnight));
      target = wallMidnight - zoneOffset(tz, new Date(target));
      const left = Math.max(0, Math.floor((target - now.getTime()) / 1000));
      // The instant of midnight itself reads as 00:00:00, not 24:00:00.
      return left === 86400 ? 0 : left;
    } catch (e) {
      const next = new Date(now);
      next.setHours(24, 0, 0, 0);
      return Math.max(0, Math.floor((next - now) / 1000));
    }
  }

  const pad = (n) => String(n).padStart(2, '0');

  function renderCountdown(el) {
    const left = secondsToMidnight(el.dataset.tz || 'America/Chicago');
    const hours = Math.floor(left / 3600);
    const mins = Math.floor((left % 3600) / 60);
    const secs = left % 60;
    el.querySelectorAll('[data-hours]').forEach((n) => (n.textContent = pad(hours)));
    el.querySelectorAll('[data-mins]').forEach((n) => (n.textContent = pad(mins)));
    el.querySelectorAll('[data-secs]').forEach((n) => (n.textContent = pad(secs)));
    el.classList.add('is-ticking');
  }

  function initCountdowns(root = document) {
    root.querySelectorAll('[data-sm-countdown]').forEach(renderCountdown);
  }

  initCountdowns();
  setInterval(() => initCountdowns(), 1000);
  document.addEventListener('shopify:section:load', (e) => initCountdowns(e.target));

  /* ---------- Bundle picker ---------- */
  // Drives Horizon's native <variant-picker> so price, media, URL and the add-to-cart form
  // all update through the theme's own code path.
  class SmBundlePicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.value) return;
      event.stopPropagation();
      this.querySelectorAll('.sm-bundle').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(input));
      });
      const scope =
        this.closest('product-information, featured-product-information, .product-information, section, .shopify-section') ||
        document;
      const native = scope.querySelector(`variant-picker input[data-variant-id="${CSS.escape(input.value)}"]`);
      if (native) {
        if (!native.checked) {
          native.checked = true;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      // Fallback: point the product form straight at the chosen variant.
      scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((idInput) => {
        idInput.value = input.value;
      });
    };
  }

  if (!customElements.get('sm-bundle-picker')) {
    customElements.define('sm-bundle-picker', SmBundlePicker);
  }
})();
